import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "mb-3" }
const _hoisted_2 = {
  key: 0,
  for: "name",
  class: "form-label"
}
const _hoisted_3 = ["placeholder", "disabled", "readonly", "value"]

import { ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'inputPrice',
  props: {
    modelValue: {
        type: Number,
        default: 0,
    },
    label: String,
    placeholder: {
        type: String,
        default: 'Enter price',
    },
    disabled: Boolean,
    readonly: Boolean,
    v: {
        type: Object,
    }
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emits = __emit;
const handleInput = (event) => {
    emits('update:modelValue', event.target.value);
}

const isFloat = (event) => {
    const keyCode = event.keyCode ? event.keyCode : event.which;
    const currentValue = event.target.value;
    // Allow only numbers (0-9) and a single decimal point (.)
    if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        event.preventDefault();
    }
    // Check if there is already a decimal point in the input
    if (currentValue.indexOf('.') !== -1 && keyCode === 46) {
        event.preventDefault();
    }
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("b", _hoisted_2, _toDisplayString(__props.label), 1))
      : _createCommentVNode("", true),
    _createElementVNode("input", {
      type: "text",
      placeholder: __props.label,
      disabled: __props.disabled,
      readonly: __props.readonly,
      value: __props.modelValue,
      onInput: _cache[0] || (_cache[0] = ($event: any) => (handleInput($event))),
      onKeypress: _cache[1] || (_cache[1] = ($event: any) => (isFloat($event))),
      class: "form-control"
    }, null, 40, _hoisted_3),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.v?.$errors, (error) => {
      return (_openBlock(), _createElementBlock("span", {
        class: "text-danger",
        key: error.$uid
      }, [
        _createTextVNode(" - " + _toDisplayString(error.$message) + " ", 1),
        _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1))
      ]))
    }), 128))
  ]))
}
}

})